  <template>
  <div>
    <v-dialog v-model="dialog" max-width="500px" :retain-focus="false">
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" v-bind:valid="valid" lazy-validation>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="editedItem.name"
                    :label="$t('_place.name')"
                    required
                    :rules="nameRules"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-textarea
                    v-model="editedItem.address"
                    :label="$t('_place.address')"
                    rows="2"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-select
                    v-model="editedItem.countyCode"
                    :label="$t('_place.county')"
                    :items="counties"
                    item-text="name"
                    item-value="code"
                    :rules="countyRules"
                    @change="changeNeigh(editedItem.countyCode)"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-select
                    v-model="editedItem.neighborhoodCode"
                    :label="$t('_place.neighborhood')"
                    :items="
                      neighborhoods.filter(
                        (n) => n.countyCode === this.editedItem.countyCode
                      )
                    "
                    item-text="name"
                    item-value="code"
                    :disabled="this.editedItem.countyCode === null"
                    required
                    :rules="neighborhoodRules"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="editedItem.lat"
                    :label="$t('_place.lat')"
                    :rules="latRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="editedItem.lon"
                    :label="$t('_place.lon')"
                    :rules="lonRules"
                  ></v-text-field>
                </v-col>
                <v-col class="d-flex flex-column" cols="12" sm="4">
                  <v-btn
                    style="margin-top: 15px"
                    color="blue darken-1"
                    text
                    @click="mapDialog = true"
                  >
                    {{ $t("_map._select").toLocaleUpperCase(lang) }}
                  </v-btn>
                  <v-map-location-select
                    type="place"
                    :mapDialog.sync="mapDialog"
                    :cId="categoryId"
                    :routeName="routeName"
                    :points="editedItem"
                    @confirmedLoc="onConfirmedLoc"
                    @cancelledLoc="onCancelledLoc"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="editedItem.phone"
                    placeholder="+90 (xxx) xxx xx xx"
                    v-mask="'+90 (###) ### ## ##'"
                    :label="$t('_place.phone')"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
            <!-- <VMap :categoryId="routeId" :showType="incidents" /> -->
          </v-form>
          <p v-if="hasError == true" class="red--text">{{ errorMessage }}</p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">
            {{ $t("common.cancel") }}
          </v-btn>
          <v-btn color="blue darken-1" text @click="save" v-bind:valid="valid">
            {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      elevation="24"
      :color="snackColor"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Kapat
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import VMap from "@/components/ui/VMap.vue";
import VMapLocationSelect from "@/components/ui/VMapLocationSelect.vue";
import { mapGetters } from "vuex";

export default {
  components: { VMap, VMapLocationSelect },
  props: {
    dialog: Boolean,
    editedItem: Object,
    editedIndex: Number,
    counties: Array,
    neighborhoods: Array,
    routeName: String,
    categoryId: String,
  },
  data() {
    return {
      valid: false,
      disabled: false,
      mapDialog: false,
      dialog: false,
      dialogDelete: false,
      defaultItem: {
        name: "",
        address: "",
        phone: "",
      },
      snackbar: false,
      snackColor: "",
      snackText: "",
      x: null,
      y: null,
      mode: null,
      timeout: 3000,
      nameRules: [(v) => !!v || "Ad Girilmelidir"],
      countyRules: [(v) => !!v || "İlçe Seçilmelidir"],
      neighborhoodRules: [(v) => !!v || "Mahalle Girilmelidir"],
      latRules: [
        (v) => !!v || "Enlem Girilmelidir",
        (v) =>
          // /^(\+|-)?((\d((\.)|\.\d{1,6})?)|(0*?[0-8]\d((\.)|\.\d{1,6})?)|(0*?90((\.)|\.0{1,6})?))$/.test(v) ||
          // /^[+-]?\d*\.\d+$|^[+-]?\d+(\.\d*)?$/.test(v) ||
          // /^(\+|-)?(?:90(?:(?:\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,6})?))$/.test(v) ||
          /^(\+|-)?(?:90(?:(?:\.0{1,15})?)|(?:[3][6-9]|[4][0-2])(?:(?:\.[0-9]{1,15})?))$/.test(
            v
          ) ||
          "Türkiye sınırları içerisinde geçerli bir enlem girilmelidir! (36.xx - 42.xx)",
      ],
      lonRules: [
        (v) => !!v || "Boylam Girilmelidir",
        (v) =>
          // ^[+-]?\d*\.\d+$|^[+-]?\d+(\.\d*)?$
          /^(\+|-)?(?:180(?:(?:\.0{1,15})?)|(?:[2][6-9]|[3][0-9]|[4][0-5])(?:(?:\.[0-9]{1,15})?))$/.test(
            v
          ) ||
          "Türkiye sınırları içerisinde geçerli bir boylam girilmelidir! (26.xx - 45.xx)",
      ],
      hasError: false,
      errorMessage: "Zorunlu alanlar doldurulmalıdır!",
      locSelected: [{ lat: null, lon: null }],
    };
  },

  computed: {
    ...mapGetters({ language: "app/language" }),
    lang() {
      return this.language.replaceAll("_", "-");
    },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("common.new") + " " + this.routeName
        : this.$t("common.edit");
    },
  },
  watch: {
    dialog(val) {
      this.hasError = false;
      this.$refs.form.resetValidation();
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  methods: {
    changeNeigh(county) {},
    close() {
      this.dialog = false;
      this.$emit("cancelled");

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      console.log("addddedddddd");
      if (this.$refs.form.validate()) {
        this.hasError = false;
        this.valid = true;
        if (this.editedIndex > -1) {
          //Object.assign(this.counties[this.editedIndex], this.editedItem);
          try {
            await this.$store.dispatch("places/update", {
              name: this.editedItem.name,
              cityCode: this.editedItem.cityCode,
              countyCode: this.editedItem.countyCode,
              neighborhoodCode: this.editedItem.neighborhoodCode,
              categoryId: this.categoryId,
              address: this.editedItem.address,
              phone: this.phoneTrim(this.editedItem.phone),
              lat: this.editedItem.lat,
              lon: this.editedItem.lon,
              id: this.editedItem.id,
              editedIndex: this.editedIndex,
            });
            console.log("editeddddd");
            this.snackbar = true;
            this.snackColor = "success";
            this.snackText = "Kayıt güncellendi";
          } catch (e) {
            this.snackbar = true;
            this.snackColor = "error";
            this.snackText = "Kayıt güncellenemedi";

            console.error(e);
          }
        } else {
          try {
            await this.$store.dispatch("places/create", {
              name: this.editedItem.name,
              cityCode: this.editedItem.cityCode,
              countyCode: this.editedItem.countyCode,
              neighborhoodCode: this.editedItem.neighborhoodCode,
              categoryId: this.categoryId,
              address: this.editedItem.address,
              phone: this.phoneTrim(this.editedItem.phone),
              lat: this.editedItem.lat,
              lon: this.editedItem.lon,
            });
            this.editedItem.name = "";
            this.editedItem.countyCode = "";
            this.editedItem.neighborhoodCode = "";
            this.editedItem.address = "";
            this.editedItem.phone = "";
            this.editedItem.lat = "";
            this.editedItem.lon = "";
            this.snackbar = true;
            this.snackColor = "success";
            this.snackText = "Kayıt eklendi";
            this.x = "center";
            this.y = "bottom";
          } catch (e) {
            this.snackbar = true;
            this.snackColor = "error";
            this.snackText = "Kayıt eklenemedi";
            this.x = "center";
            this.y = "bottom";
          }
        }
        this.$emit("confirmed", this.editedItem);
        this.close();
      } else {
        this.hasError = true;
      }
    },
    onConfirmedLoc(coords) {
      // hide a dialog
      this.locSelected.lat = coords[1].toFixed(6);
      this.locSelected.lon = coords[0].toFixed(6);
      this.editedItem.lat = parseFloat(coords[1].toFixed(6));
      this.editedItem.lon = parseFloat(coords[0].toFixed(6));
      this.mapDialog = false;
      // save a user and refresh a table
    },
    onCancelledLoc(coords) {
      // hide a dialog
      coords[0] = this.editedItem.lon;
      coords[1] = this.editedItem.lat;
      this.mapDialog = false;
    },
    phoneTrim(phone_number) {
      console.log(
        "telefoonononoonn",
        phone_number.replace(/[()\s]/g, "").replace(/^\+90/, "")
      );
      return phone_number.replace(/[()\s]/g, "").replace(/^\+90/, "");
    },
  },
};
</script>